import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=7951dc72&scoped=true&"
import script from "./Setting.vue?vue&type=script&lang=js&"
export * from "./Setting.vue?vue&type=script&lang=js&"
import style0 from "./Setting.vue?vue&type=style&index=0&id=7951dc72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7951dc72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\project\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7951dc72')) {
      api.createRecord('7951dc72', component.options)
    } else {
      api.reload('7951dc72', component.options)
    }
    module.hot.accept("./Setting.vue?vue&type=template&id=7951dc72&scoped=true&", function () {
      api.rerender('7951dc72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/Setting.vue"
export default component.exports